import React, { useState } from "react";
import "../css/Faqs.css";

const faqData = [
  {
    q: "What makes Shank different?",
    a: "Shank blends fun, movement, and colorful experiences. We create a fitness space where progress feels playful — not stressful."
  },
  {
    q: "Do I need experience to join classes?",
    a: "No experience needed! Every class has beginner-friendly modifications so anyone can jump in and enjoy."
  },
  {
    q: "Are personal coaching sessions available?",
    a: "Yes! Our coaches offer 1-on-1 personalized sessions based on your goals, lifestyle, and vibe."
  },
  {
    q: "Is there a trial membership?",
    a: "Yes! We offer a 7-day trial so you can explore classes, trainers, and tracking tools before fully joining."
  },
  {
    q: "Do you help with nutrition?",
    a: "Absolutely — we offer simple, realistic meal guides and practical habit support."
  }
];

const Faqs = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="faqs4">

      {/* ================= HERO ================= */}
      <section className="f4-hero">
        <h1>FAQs</h1>
        <p>Your questions — answered with clarity and color.</p>

        <div className="hero-blob hb1"></div>
        <div className="hero-blob hb2"></div>
      </section>


      {/* ================= ACCORDION ================= */}
      <section className="f4-accordion">

        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-box ${openIndex === index ? "open" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-q">
              <h3>{item.q}</h3>
              <span>{openIndex === index ? "−" : "+"}</span>
            </div>

            <div className="faq-a">
              <p>{item.a}</p>
            </div>
          </div>
        ))}

      </section>

    </div>
  );
};

export default Faqs;
